/**
 * aiChatConversations · 拉当前 user+group 下的历史会话列表
 *
 * 后端协议：
 *   POST /web/workgroup/folder/ai/chat/conversations
 *   body: { page?, page_size? }（都可空，默认 page=1 page_size=20）
 *   resp: {
 *     conversations: [
 *       { id, conversation_id, user_id, group_id, title, type, created_at, updated_at },
 *       ...
 *     ],
 *     page, page_size
 *   }
 *
 * 后端 DB 索引：ai_chat_conversation (user_id, group_id) → 命中索引快，无需改 schema。
 * 后端按 updated_at desc 排序，最近活跃的在前。
 */

declare const __API_SERVER_HOST__: string

/** 后端 ai_chat_conversation 一行（json tag 严格匹配 model/chat.go） */
export interface BackendConversation {
  id: number
  conversation_id: string
  user_id: string
  group_id: string
  title: string
  type: string
  created_at: string
  updated_at: string
}

interface ConversationsRequest {
  /** webxcameraapi BFF 强校验所有 ai/chat/* 路由必须含 group_id（UUID 形式） */
  group_id: string
  page?: number
  page_size?: number
}

interface ConversationsResponse {
  conversations: BackendConversation[]
  page: number
  page_size: number
}

/** 拉历史会话列表 · 已按 user_id + group_id 过滤（cookie 里的当前用户 + body.group_id） */
export async function fetchAiChatConversations(
  groupID: string,
  page = 1,
  pageSize = 20,
  signal?: AbortSignal
): Promise<ConversationsResponse> {
  const url =
    __API_SERVER_HOST__ + '/web/workgroup/folder/ai/chat/conversations'
  const body: ConversationsRequest = {
    group_id: groupID,
    page,
    page_size: pageSize
  }
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal
  })
  if (!res.ok) {
    throw new Error(`HTTP ${res.status} ${res.statusText}`)
  }
  const json = await res.json()
  return json && json.data !== undefined ? json.data : json
}
